export default {
	fill_form_with_data_of_whom_you_recommend_and_we_will_contact_you: "Сиз сунуштаган адамдын маалыматы менен форманы толтуруңуз, жана биз сиз менен байланышабыз:",
	fill_form_yourself: "Форманы өзүңүз толтуруңуз!",
	how_referral_system_works: 'Рефералдык система кантип иштейт?',
	immediately_after_first_payment_of_your_referral: "Сиздин рефералыңыздын биринчи төлөмүнөн кийин дароо эле",
	let_your_friend_scan_qr: "Досуңузга QR кодун сканерлөөсүнө уруксат бериңиз",
	let_your_friend_scan_qr_below: "Досуңузга төмөнкү QR кодду сканерлөөсүнө уруксат бериңиз",
	or: "же",
	receive_payment_from_our_manager_on_your_card: "Төлөмүңүздү биздин менеджерден картаңызга алыңыз",
	receive_reward_for_first_payment: "Сиздин рефералыңыздын биринчи төлөмү үчүн <span class='text-primary'>{reward}</span> {currency} алыңыз",
	recommend_dentist_plus_to_your_friends: "Биздин өнөктөштүк программабыз аркылуу досторуңузга Dentist + сунуштаңыз жана сыйлык алыңыз:",
	recommend_dentist_plus_to_your_friends_with_any_method: "Сиз каалаган ыкманы колдонуп, досторуңузга Dentist + сунуштаңыз:",
	referral_system_for_users: 'Колдонуучулар үчүн рефералдык система',
	start_earning_right_now: 'Азыртан киреше таба баштаңыз!'
}
